module.exports = __webpack_public_path__ + "img/pickup-pin.d7132fb8.svg";